import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  overflow: hidden;

  background-color: white;
`;

export const ContainerContent = styled.div`
  background: ${(props) => props.theme.colors.greys.lighter};

  width: 100%;
  position: relative;
  height: calc(100% - 40px);

  overflow: scroll;

  background: ${(props) => props.theme.colors.greys.lighter};

  .planning-analytics-corner-ref {
    height: 48px;

    margin-top: 3px;
    padding-top: 0px;
  }

  .planning-analytics-selectors {
    padding-top: 65px;
  }
`;
